import { DeviceSettingsStateType } from './state'

export interface DeviceSettingsGettersType {
  getDeviceSettingsById: (state: DeviceSettingsStateType, id: string) => DeviceSettingsStateType['singleDeviceSettings']
  getDeviceSettingsByDeviceId: (state: DeviceSettingsStateType, deviceId: string) => DeviceSettingsStateType['deviceSettings']
  getActiveDeviceSettingsByDeviceId: (state: DeviceSettingsStateType, deviceId: string) => DeviceSettingsStateType['deviceSettings']
}

export const DeviceSettingsGetters = {
  getDeviceSettingsById: (state: DeviceSettingsStateType) => (id: string) => {
    return state.deviceSettings.find(settings => settings.id === id)
  },
  getDeviceSettingsByDeviceId: (state: DeviceSettingsStateType) => (deviceId: string) => {
    return state.deviceSettings.filter(settings => settings.deviceId === deviceId)
  },
  getActiveDeviceSettingsByDeviceId: (state: DeviceSettingsStateType) => (deviceId: string) => {
    return state.deviceSettings.filter(settings => settings.deviceId === deviceId && settings.active)
  },
}
